"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GB = void 0;
exports.GB = {
    numericCode: '826',
    alpha2Code: 'GB',
    alpha3Code: 'GBR',
    englishName: {
        short: 'United Kingdom of Great Britain and Northern Ireland (the)',
        full: 'the United Kingdom of Great Britain and Northern Ireland',
    },
    names: {
        full: {
            en: 'the United Kingdom of Great Britain and Northern Ireland',
            fr: "le Royaume-Uni de Grande-Bretagne et d'Irlande du Nord",
        },
        short: {
            en: 'United Kingdom of Great Britain and Northern Ireland (the)',
            fr: "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord (le)",
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'GB-ENG': {
            numericCode: '826',
            code: 'GB-ENG',
            category: {
                id: '491',
                names: {
                    en: {
                        singular: 'country',
                        plural: 'countries',
                    },
                    fr: {
                        singular: 'pays',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'England',
            },
        },
        'GB-BKM': {
            numericCode: '826',
            code: 'GB-BKM',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Buckinghamshire',
            },
        },
        'GB-CAM': {
            numericCode: '826',
            code: 'GB-CAM',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Cambridgeshire',
            },
        },
        'GB-CMA': {
            numericCode: '826',
            code: 'GB-CMA',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Cumbria',
            },
        },
        'GB-DBY': {
            numericCode: '826',
            code: 'GB-DBY',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Derbyshire',
            },
        },
        'GB-DEV': {
            numericCode: '826',
            code: 'GB-DEV',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Devon',
            },
        },
        'GB-DOR': {
            numericCode: '826',
            code: 'GB-DOR',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Dorset',
            },
        },
        'GB-ESS': {
            numericCode: '826',
            code: 'GB-ESS',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Essex',
            },
        },
        'GB-ESX': {
            numericCode: '826',
            code: 'GB-ESX',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'East Sussex',
            },
        },
        'GB-GLS': {
            numericCode: '826',
            code: 'GB-GLS',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Gloucestershire',
            },
        },
        'GB-HAM': {
            numericCode: '826',
            code: 'GB-HAM',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Hampshire',
            },
        },
        'GB-HRT': {
            numericCode: '826',
            code: 'GB-HRT',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Hertfordshire',
            },
        },
        'GB-KEN': {
            numericCode: '826',
            code: 'GB-KEN',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Kent',
            },
        },
        'GB-LAN': {
            numericCode: '826',
            code: 'GB-LAN',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Lancashire',
            },
        },
        'GB-LEC': {
            numericCode: '826',
            code: 'GB-LEC',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Leicestershire',
            },
        },
        'GB-LIN': {
            numericCode: '826',
            code: 'GB-LIN',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Lincolnshire',
            },
        },
        'GB-NFK': {
            numericCode: '826',
            code: 'GB-NFK',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Norfolk',
            },
        },
        'GB-NTH': {
            numericCode: '826',
            code: 'GB-NTH',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Northamptonshire',
            },
        },
        'GB-NTT': {
            numericCode: '826',
            code: 'GB-NTT',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Nottinghamshire',
            },
        },
        'GB-NYK': {
            numericCode: '826',
            code: 'GB-NYK',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'North Yorkshire',
            },
        },
        'GB-OXF': {
            numericCode: '826',
            code: 'GB-OXF',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Oxfordshire',
            },
        },
        'GB-SFK': {
            numericCode: '826',
            code: 'GB-SFK',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Suffolk',
            },
        },
        'GB-SOM': {
            numericCode: '826',
            code: 'GB-SOM',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Somerset',
            },
        },
        'GB-SRY': {
            numericCode: '826',
            code: 'GB-SRY',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Surrey',
            },
        },
        'GB-STS': {
            numericCode: '826',
            code: 'GB-STS',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Staffordshire',
            },
        },
        'GB-WAR': {
            numericCode: '826',
            code: 'GB-WAR',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Warwickshire',
            },
        },
        'GB-WOR': {
            numericCode: '826',
            code: 'GB-WOR',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Worcestershire',
            },
        },
        'GB-WSX': {
            numericCode: '826',
            code: 'GB-WSX',
            category: {
                id: '113',
                names: {
                    en: {
                        singular: 'two-tier county',
                        plural: 'two-tier counties',
                    },
                    fr: {
                        singular: 'comté à 2 niveaux',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'West Sussex',
            },
        },
        'GB-BAS': {
            numericCode: '826',
            code: 'GB-BAS',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bath and North East Somerset',
            },
        },
        'GB-BBD': {
            numericCode: '826',
            code: 'GB-BBD',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Blackburn with Darwen',
            },
        },
        'GB-BCP': {
            numericCode: '826',
            code: 'GB-BCP',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bournemouth, Christchurch and Poole',
            },
        },
        'GB-BDF': {
            numericCode: '826',
            code: 'GB-BDF',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bedford',
            },
        },
        'GB-BNH': {
            numericCode: '826',
            code: 'GB-BNH',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Brighton and Hove',
            },
        },
        'GB-BPL': {
            numericCode: '826',
            code: 'GB-BPL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Blackpool',
            },
        },
        'GB-BRC': {
            numericCode: '826',
            code: 'GB-BRC',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bracknell Forest',
            },
        },
        'GB-BST': {
            numericCode: '826',
            code: 'GB-BST',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bristol, City of',
            },
        },
        'GB-CBF': {
            numericCode: '826',
            code: 'GB-CBF',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Central Bedfordshire',
            },
        },
        'GB-CHE': {
            numericCode: '826',
            code: 'GB-CHE',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Cheshire East',
            },
        },
        'GB-CHW': {
            numericCode: '826',
            code: 'GB-CHW',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Cheshire West and Chester',
            },
        },
        'GB-CON': {
            numericCode: '826',
            code: 'GB-CON',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Cornwall',
            },
        },
        'GB-DAL': {
            numericCode: '826',
            code: 'GB-DAL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Darlington',
            },
        },
        'GB-DER': {
            numericCode: '826',
            code: 'GB-DER',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Derby',
            },
        },
        'GB-DUR': {
            numericCode: '826',
            code: 'GB-DUR',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Durham, County',
            },
        },
        'GB-ERY': {
            numericCode: '826',
            code: 'GB-ERY',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'East Riding of Yorkshire',
            },
        },
        'GB-HAL': {
            numericCode: '826',
            code: 'GB-HAL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Halton',
            },
        },
        'GB-HEF': {
            numericCode: '826',
            code: 'GB-HEF',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Herefordshire',
            },
        },
        'GB-HPL': {
            numericCode: '826',
            code: 'GB-HPL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Hartlepool',
            },
        },
        'GB-IOS': {
            numericCode: '826',
            code: 'GB-IOS',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Isles of Scilly',
            },
        },
        'GB-IOW': {
            numericCode: '826',
            code: 'GB-IOW',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Isle of Wight',
            },
        },
        'GB-KHL': {
            numericCode: '826',
            code: 'GB-KHL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Kingston upon Hull',
            },
        },
        'GB-LCE': {
            numericCode: '826',
            code: 'GB-LCE',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Leicester',
            },
        },
        'GB-LUT': {
            numericCode: '826',
            code: 'GB-LUT',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Luton',
            },
        },
        'GB-MDB': {
            numericCode: '826',
            code: 'GB-MDB',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Middlesbrough',
            },
        },
        'GB-MDW': {
            numericCode: '826',
            code: 'GB-MDW',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Medway',
            },
        },
        'GB-MIK': {
            numericCode: '826',
            code: 'GB-MIK',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Milton Keynes',
            },
        },
        'GB-NBL': {
            numericCode: '826',
            code: 'GB-NBL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Northumberland',
            },
        },
        'GB-NEL': {
            numericCode: '826',
            code: 'GB-NEL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'North East Lincolnshire',
            },
        },
        'GB-NGM': {
            numericCode: '826',
            code: 'GB-NGM',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Nottingham',
            },
        },
        'GB-NLN': {
            numericCode: '826',
            code: 'GB-NLN',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'North Lincolnshire',
            },
        },
        'GB-NSM': {
            numericCode: '826',
            code: 'GB-NSM',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'North Somerset',
            },
        },
        'GB-PEM': {
            numericCode: '826',
            code: 'GB-PEM',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Pembrokeshire [Sir Benfro GB-BNF]',
            },
        },
        'GB-PLY': {
            numericCode: '826',
            code: 'GB-PLY',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Plymouth',
            },
        },
        'GB-POR': {
            numericCode: '826',
            code: 'GB-POR',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Portsmouth',
            },
        },
        'GB-PTE': {
            numericCode: '826',
            code: 'GB-PTE',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Peterborough',
            },
        },
        'GB-RCC': {
            numericCode: '826',
            code: 'GB-RCC',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Redcar and Cleveland',
            },
        },
        'GB-RDG': {
            numericCode: '826',
            code: 'GB-RDG',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Reading',
            },
        },
        'GB-RUT': {
            numericCode: '826',
            code: 'GB-RUT',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Rutland',
            },
        },
        'GB-SGC': {
            numericCode: '826',
            code: 'GB-SGC',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'South Gloucestershire',
            },
        },
        'GB-SHR': {
            numericCode: '826',
            code: 'GB-SHR',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Shropshire',
            },
        },
        'GB-SLG': {
            numericCode: '826',
            code: 'GB-SLG',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Slough',
            },
        },
        'GB-SOS': {
            numericCode: '826',
            code: 'GB-SOS',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Southend-on-Sea',
            },
        },
        'GB-STE': {
            numericCode: '826',
            code: 'GB-STE',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Stoke-on-Trent',
            },
        },
        'GB-STH': {
            numericCode: '826',
            code: 'GB-STH',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Southampton',
            },
        },
        'GB-STT': {
            numericCode: '826',
            code: 'GB-STT',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Stockton-on-Tees',
            },
        },
        'GB-SWD': {
            numericCode: '826',
            code: 'GB-SWD',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Swindon',
            },
        },
        'GB-TFW': {
            numericCode: '826',
            code: 'GB-TFW',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Telford and Wrekin',
            },
        },
        'GB-THR': {
            numericCode: '826',
            code: 'GB-THR',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Thurrock',
            },
        },
        'GB-TOB': {
            numericCode: '826',
            code: 'GB-TOB',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Torbay',
            },
        },
        'GB-WBK': {
            numericCode: '826',
            code: 'GB-WBK',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'West Berkshire',
            },
        },
        'GB-WIL': {
            numericCode: '826',
            code: 'GB-WIL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Wiltshire',
            },
        },
        'GB-WNM': {
            numericCode: '826',
            code: 'GB-WNM',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Windsor and Maidenhead',
            },
        },
        'GB-WOK': {
            numericCode: '826',
            code: 'GB-WOK',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Wokingham',
            },
        },
        'GB-WRT': {
            numericCode: '826',
            code: 'GB-WRT',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Warrington',
            },
        },
        'GB-YOR': {
            numericCode: '826',
            code: 'GB-YOR',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'York',
            },
        },
        'GB-BIR': {
            numericCode: '826',
            code: 'GB-BIR',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Birmingham',
            },
        },
        'GB-BNS': {
            numericCode: '826',
            code: 'GB-BNS',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Barnsley',
            },
        },
        'GB-BOL': {
            numericCode: '826',
            code: 'GB-BOL',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bolton',
            },
        },
        'GB-BRD': {
            numericCode: '826',
            code: 'GB-BRD',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bradford',
            },
        },
        'GB-BUR': {
            numericCode: '826',
            code: 'GB-BUR',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bury',
            },
        },
        'GB-CLD': {
            numericCode: '826',
            code: 'GB-CLD',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Calderdale',
            },
        },
        'GB-COV': {
            numericCode: '826',
            code: 'GB-COV',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Coventry',
            },
        },
        'GB-DNC': {
            numericCode: '826',
            code: 'GB-DNC',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Doncaster',
            },
        },
        'GB-DUD': {
            numericCode: '826',
            code: 'GB-DUD',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Dudley',
            },
        },
        'GB-GAT': {
            numericCode: '826',
            code: 'GB-GAT',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Gateshead',
            },
        },
        'GB-KIR': {
            numericCode: '826',
            code: 'GB-KIR',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Kirklees',
            },
        },
        'GB-KWL': {
            numericCode: '826',
            code: 'GB-KWL',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Knowsley',
            },
        },
        'GB-LDS': {
            numericCode: '826',
            code: 'GB-LDS',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Leeds',
            },
        },
        'GB-LIV': {
            numericCode: '826',
            code: 'GB-LIV',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Liverpool',
            },
        },
        'GB-MAN': {
            numericCode: '826',
            code: 'GB-MAN',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Manchester',
            },
        },
        'GB-NET': {
            numericCode: '826',
            code: 'GB-NET',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Newcastle upon Tyne',
            },
        },
        'GB-NTY': {
            numericCode: '826',
            code: 'GB-NTY',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'North Tyneside',
            },
        },
        'GB-OLD': {
            numericCode: '826',
            code: 'GB-OLD',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Oldham',
            },
        },
        'GB-RCH': {
            numericCode: '826',
            code: 'GB-RCH',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Rochdale',
            },
        },
        'GB-ROT': {
            numericCode: '826',
            code: 'GB-ROT',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Rotherham',
            },
        },
        'GB-SAW': {
            numericCode: '826',
            code: 'GB-SAW',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Sandwell',
            },
        },
        'GB-SFT': {
            numericCode: '826',
            code: 'GB-SFT',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Sefton',
            },
        },
        'GB-SHF': {
            numericCode: '826',
            code: 'GB-SHF',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Sheffield',
            },
        },
        'GB-SHN': {
            numericCode: '826',
            code: 'GB-SHN',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'St. Helens',
            },
        },
        'GB-SKP': {
            numericCode: '826',
            code: 'GB-SKP',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Stockport',
            },
        },
        'GB-SLF': {
            numericCode: '826',
            code: 'GB-SLF',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Salford',
            },
        },
        'GB-SND': {
            numericCode: '826',
            code: 'GB-SND',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Sunderland',
            },
        },
        'GB-SOL': {
            numericCode: '826',
            code: 'GB-SOL',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Solihull',
            },
        },
        'GB-STY': {
            numericCode: '826',
            code: 'GB-STY',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'South Tyneside',
            },
        },
        'GB-TAM': {
            numericCode: '826',
            code: 'GB-TAM',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Tameside',
            },
        },
        'GB-TRF': {
            numericCode: '826',
            code: 'GB-TRF',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Trafford',
            },
        },
        'GB-WGN': {
            numericCode: '826',
            code: 'GB-WGN',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Wigan',
            },
        },
        'GB-WKF': {
            numericCode: '826',
            code: 'GB-WKF',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Wakefield',
            },
        },
        'GB-WLL': {
            numericCode: '826',
            code: 'GB-WLL',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Walsall',
            },
        },
        'GB-WLV': {
            numericCode: '826',
            code: 'GB-WLV',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Wolverhampton',
            },
        },
        'GB-WRL': {
            numericCode: '826',
            code: 'GB-WRL',
            category: {
                id: '369',
                names: {
                    en: {
                        singular: 'metropolitan district',
                        plural: 'metropolitan districts',
                    },
                    fr: {
                        singular: 'district métropolitain',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Wirral',
            },
        },
        'GB-BDG': {
            numericCode: '826',
            code: 'GB-BDG',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Barking and Dagenham',
            },
        },
        'GB-BEN': {
            numericCode: '826',
            code: 'GB-BEN',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Brent',
            },
        },
        'GB-BEX': {
            numericCode: '826',
            code: 'GB-BEX',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bexley',
            },
        },
        'GB-BNE': {
            numericCode: '826',
            code: 'GB-BNE',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Barnet',
            },
        },
        'GB-BRY': {
            numericCode: '826',
            code: 'GB-BRY',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Bromley',
            },
        },
        'GB-CMD': {
            numericCode: '826',
            code: 'GB-CMD',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Camden',
            },
        },
        'GB-CRY': {
            numericCode: '826',
            code: 'GB-CRY',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Croydon',
            },
        },
        'GB-EAL': {
            numericCode: '826',
            code: 'GB-EAL',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Ealing',
            },
        },
        'GB-ENF': {
            numericCode: '826',
            code: 'GB-ENF',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Enfield',
            },
        },
        'GB-GRE': {
            numericCode: '826',
            code: 'GB-GRE',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Greenwich',
            },
        },
        'GB-HAV': {
            numericCode: '826',
            code: 'GB-HAV',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Havering',
            },
        },
        'GB-HCK': {
            numericCode: '826',
            code: 'GB-HCK',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Hackney',
            },
        },
        'GB-HIL': {
            numericCode: '826',
            code: 'GB-HIL',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Hillingdon',
            },
        },
        'GB-HMF': {
            numericCode: '826',
            code: 'GB-HMF',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Hammersmith and Fulham',
            },
        },
        'GB-HNS': {
            numericCode: '826',
            code: 'GB-HNS',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Hounslow',
            },
        },
        'GB-HRW': {
            numericCode: '826',
            code: 'GB-HRW',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Harrow',
            },
        },
        'GB-HRY': {
            numericCode: '826',
            code: 'GB-HRY',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Haringey',
            },
        },
        'GB-ISL': {
            numericCode: '826',
            code: 'GB-ISL',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Islington',
            },
        },
        'GB-KEC': {
            numericCode: '826',
            code: 'GB-KEC',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Kensington and Chelsea',
            },
        },
        'GB-KTT': {
            numericCode: '826',
            code: 'GB-KTT',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Kingston upon Thames',
            },
        },
        'GB-LBH': {
            numericCode: '826',
            code: 'GB-LBH',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Lambeth',
            },
        },
        'GB-LEW': {
            numericCode: '826',
            code: 'GB-LEW',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Lewisham',
            },
        },
        'GB-MRT': {
            numericCode: '826',
            code: 'GB-MRT',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Merton',
            },
        },
        'GB-NWM': {
            numericCode: '826',
            code: 'GB-NWM',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Newham',
            },
        },
        'GB-RDB': {
            numericCode: '826',
            code: 'GB-RDB',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Redbridge',
            },
        },
        'GB-RIC': {
            numericCode: '826',
            code: 'GB-RIC',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Richmond upon Thames',
            },
        },
        'GB-STN': {
            numericCode: '826',
            code: 'GB-STN',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Sutton',
            },
        },
        'GB-SWK': {
            numericCode: '826',
            code: 'GB-SWK',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Southwark',
            },
        },
        'GB-TWH': {
            numericCode: '826',
            code: 'GB-TWH',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Tower Hamlets',
            },
        },
        'GB-WFT': {
            numericCode: '826',
            code: 'GB-WFT',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Waltham Forest',
            },
        },
        'GB-WND': {
            numericCode: '826',
            code: 'GB-WND',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Wandsworth',
            },
        },
        'GB-WSM': {
            numericCode: '826',
            code: 'GB-WSM',
            category: {
                id: '370',
                names: {
                    en: {
                        singular: 'London borough',
                        plural: 'London boroughs',
                    },
                    fr: {
                        singular: 'arrondissement de Londres',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'Westminster',
            },
        },
        'GB-LND': {
            numericCode: '826',
            code: 'GB-LND',
            category: {
                id: '402',
                names: {
                    en: {
                        singular: 'city corporation',
                        plural: 'city corporations',
                    },
                    fr: {
                        singular: 'corporation urbaine',
                        plural: '',
                    },
                },
            },
            parent: 'GB-ENG',
            names: {
                en: 'London, City of',
            },
        },
        'GB-SCT': {
            numericCode: '826',
            code: 'GB-SCT',
            category: {
                id: '491',
                names: {
                    en: {
                        singular: 'country',
                        plural: 'countries',
                    },
                    fr: {
                        singular: 'pays',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Scotland',
            },
        },
        'GB-ABD': {
            numericCode: '826',
            code: 'GB-ABD',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Aberdeenshire',
            },
        },
        'GB-ABE': {
            numericCode: '826',
            code: 'GB-ABE',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Aberdeen City',
            },
        },
        'GB-AGB': {
            numericCode: '826',
            code: 'GB-AGB',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Argyll and Bute',
            },
        },
        'GB-ANS': {
            numericCode: '826',
            code: 'GB-ANS',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Angus',
            },
        },
        'GB-CLK': {
            numericCode: '826',
            code: 'GB-CLK',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Clackmannanshire',
            },
        },
        'GB-DGY': {
            numericCode: '826',
            code: 'GB-DGY',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Dumfries and Galloway',
            },
        },
        'GB-DND': {
            numericCode: '826',
            code: 'GB-DND',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Dundee City',
            },
        },
        'GB-EAY': {
            numericCode: '826',
            code: 'GB-EAY',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'East Ayrshire',
            },
        },
        'GB-EDH': {
            numericCode: '826',
            code: 'GB-EDH',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Edinburgh, City of',
            },
        },
        'GB-EDU': {
            numericCode: '826',
            code: 'GB-EDU',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'East Dunbartonshire',
            },
        },
        'GB-ELN': {
            numericCode: '826',
            code: 'GB-ELN',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'East Lothian',
            },
        },
        'GB-ELS': {
            numericCode: '826',
            code: 'GB-ELS',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Eilean Siar',
            },
        },
        'GB-ERW': {
            numericCode: '826',
            code: 'GB-ERW',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'East Renfrewshire',
            },
        },
        'GB-FAL': {
            numericCode: '826',
            code: 'GB-FAL',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Falkirk',
            },
        },
        'GB-FIF': {
            numericCode: '826',
            code: 'GB-FIF',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Fife',
            },
        },
        'GB-GLG': {
            numericCode: '826',
            code: 'GB-GLG',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Glasgow City',
            },
        },
        'GB-HLD': {
            numericCode: '826',
            code: 'GB-HLD',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Highland',
            },
        },
        'GB-IVC': {
            numericCode: '826',
            code: 'GB-IVC',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Inverclyde',
            },
        },
        'GB-MLN': {
            numericCode: '826',
            code: 'GB-MLN',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Midlothian',
            },
        },
        'GB-MRY': {
            numericCode: '826',
            code: 'GB-MRY',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Moray',
            },
        },
        'GB-NAY': {
            numericCode: '826',
            code: 'GB-NAY',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'North Ayrshire',
            },
        },
        'GB-NLK': {
            numericCode: '826',
            code: 'GB-NLK',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'North Lanarkshire',
            },
        },
        'GB-ORK': {
            numericCode: '826',
            code: 'GB-ORK',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Orkney Islands',
            },
        },
        'GB-PKN': {
            numericCode: '826',
            code: 'GB-PKN',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Perth and Kinross',
            },
        },
        'GB-RFW': {
            numericCode: '826',
            code: 'GB-RFW',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Renfrewshire',
            },
        },
        'GB-SAY': {
            numericCode: '826',
            code: 'GB-SAY',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'South Ayrshire',
            },
        },
        'GB-SCB': {
            numericCode: '826',
            code: 'GB-SCB',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Scottish Borders',
            },
        },
        'GB-SLK': {
            numericCode: '826',
            code: 'GB-SLK',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'South Lanarkshire',
            },
        },
        'GB-STG': {
            numericCode: '826',
            code: 'GB-STG',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Stirling',
            },
        },
        'GB-WDU': {
            numericCode: '826',
            code: 'GB-WDU',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'West Dunbartonshire',
            },
        },
        'GB-WLN': {
            numericCode: '826',
            code: 'GB-WLN',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'West Lothian',
            },
        },
        'GB-ZET': {
            numericCode: '826',
            code: 'GB-ZET',
            category: {
                id: '112',
                names: {
                    en: {
                        singular: 'council area',
                        plural: 'council areas',
                    },
                    fr: {
                        singular: 'zone de conseil',
                        plural: '',
                    },
                },
            },
            parent: 'GB-SCT',
            names: {
                en: 'Shetland Islands',
            },
        },
        'GB-WLS': {
            numericCode: '826',
            code: 'GB-WLS',
            category: {
                id: '491',
                names: {
                    en: {
                        singular: 'country',
                        plural: 'countries',
                    },
                    fr: {
                        singular: 'pays',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Wales [Cymru GB-CYM]',
            },
        },
        'GB-AGY': {
            numericCode: '826',
            code: 'GB-AGY',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Isle of Anglesey [Sir Ynys Môn GB-YNM]',
            },
        },
        'GB-BGE': {
            numericCode: '826',
            code: 'GB-BGE',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Bridgend [Pen-y-bont ar Ogwr GB-POG]',
            },
        },
        'GB-BGW': {
            numericCode: '826',
            code: 'GB-BGW',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Blaenau Gwent',
            },
        },
        'GB-CAY': {
            numericCode: '826',
            code: 'GB-CAY',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Caerphilly [Caerffili GB-CAF]',
            },
        },
        'GB-CGN': {
            numericCode: '826',
            code: 'GB-CGN',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Ceredigion [Sir Ceredigion]',
            },
        },
        'GB-CMN': {
            numericCode: '826',
            code: 'GB-CMN',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Carmarthenshire [Sir Gaerfyrddin GB-GFY]',
            },
        },
        'GB-CRF': {
            numericCode: '826',
            code: 'GB-CRF',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Cardiff [Caerdydd GB-CRD]',
            },
        },
        'GB-CWY': {
            numericCode: '826',
            code: 'GB-CWY',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Conwy',
            },
        },
        'GB-DEN': {
            numericCode: '826',
            code: 'GB-DEN',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Denbighshire [Sir Ddinbych GB-DDB]',
            },
        },
        'GB-FLN': {
            numericCode: '826',
            code: 'GB-FLN',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Flintshire [Sir y Fflint GB-FFL]',
            },
        },
        'GB-GWN': {
            numericCode: '826',
            code: 'GB-GWN',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Gwynedd',
            },
        },
        'GB-MON': {
            numericCode: '826',
            code: 'GB-MON',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Monmouthshire [Sir Fynwy GB-FYN]',
            },
        },
        'GB-MTY': {
            numericCode: '826',
            code: 'GB-MTY',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Merthyr Tydfil [Merthyr Tudful GB-MTU]',
            },
        },
        'GB-NTL': {
            numericCode: '826',
            code: 'GB-NTL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Neath Port Talbot [Castell-nedd Port Talbot GB-CTL]',
            },
        },
        'GB-NWP': {
            numericCode: '826',
            code: 'GB-NWP',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Newport [Casnewydd GB-CNW]',
            },
        },
        'GB-POW': {
            numericCode: '826',
            code: 'GB-POW',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Powys',
            },
        },
        'GB-RCT': {
            numericCode: '826',
            code: 'GB-RCT',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Rhondda Cynon Taff [Rhondda CynonTaf]',
            },
        },
        'GB-SWA': {
            numericCode: '826',
            code: 'GB-SWA',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Swansea [Abertawe GB-ATA]',
            },
        },
        'GB-TOF': {
            numericCode: '826',
            code: 'GB-TOF',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Torfaen [Tor-faen]',
            },
        },
        'GB-VGL': {
            numericCode: '826',
            code: 'GB-VGL',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Vale of Glamorgan, The [Bro Morgannwg GB-BMG]',
            },
        },
        'GB-WRX': {
            numericCode: '826',
            code: 'GB-WRX',
            category: {
                id: '284',
                names: {
                    en: {
                        singular: 'unitary authority',
                        plural: 'unitary authorities',
                    },
                    fr: {
                        singular: 'autorité unitaire',
                        plural: '',
                    },
                },
            },
            parent: 'GB-WLS',
            names: {
                en: 'Wrexham [Wrecsam GB-WRC]',
            },
        },
        'GB-NIR': {
            numericCode: '826',
            code: 'GB-NIR',
            category: {
                id: '492',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Northern Ireland',
            },
        },
        'GB-ABC': {
            numericCode: '826',
            code: 'GB-ABC',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Armagh City, Banbridge and Craigavon',
            },
        },
        'GB-AND': {
            numericCode: '826',
            code: 'GB-AND',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Ards and North Down',
            },
        },
        'GB-ANN': {
            numericCode: '826',
            code: 'GB-ANN',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Antrim and Newtownabbey',
            },
        },
        'GB-BFS': {
            numericCode: '826',
            code: 'GB-BFS',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Belfast City',
            },
        },
        'GB-CCG': {
            numericCode: '826',
            code: 'GB-CCG',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Causeway Coast and Glens',
            },
        },
        'GB-DRS': {
            numericCode: '826',
            code: 'GB-DRS',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Derry and Strabane',
            },
        },
        'GB-FMO': {
            numericCode: '826',
            code: 'GB-FMO',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Fermanagh and Omagh',
            },
        },
        'GB-LBC': {
            numericCode: '826',
            code: 'GB-LBC',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Lisburn and Castlereagh',
            },
        },
        'GB-MEA': {
            numericCode: '826',
            code: 'GB-MEA',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Mid and East Antrim',
            },
        },
        'GB-MUL': {
            numericCode: '826',
            code: 'GB-MUL',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Mid-Ulster',
            },
        },
        'GB-NMD': {
            numericCode: '826',
            code: 'GB-NMD',
            category: {
                id: '283',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: 'GB-NIR',
            names: {
                en: 'Newry, Mourne and Down',
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR0IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY291bnRyaWVzL2RhdGEvR0IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7O0dBSUc7OztBQU1VLFFBQUEsRUFBRSxHQUFZO0lBQ3ZCLFdBQVcsRUFBRSxLQUFLO0lBQ2xCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFdBQVcsRUFBRTtRQUNULEtBQUssRUFBRSw0REFBNEQ7UUFDbkUsSUFBSSxFQUFFLDBEQUEwRDtLQUNuRTtJQUNELEtBQUssRUFBRTtRQUNILElBQUksRUFBRTtZQUNGLEVBQUUsRUFBRSwwREFBMEQ7WUFDOUQsRUFBRSxFQUFFLHdEQUF3RDtTQUMvRDtRQUNELEtBQUssRUFBRTtZQUNILEVBQUUsRUFBRSw0REFBNEQ7WUFDaEUsRUFBRSxFQUFFLDBEQUEwRDtTQUNqRTtLQUNKO0lBQ0QsU0FBUyxFQUFFO1FBQ1A7WUFDSSxrQkFBa0IsRUFBRSxJQUFJO1lBQ3hCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsSUFBSTtTQUN6QjtRQUNEO1lBQ0ksa0JBQWtCLEVBQUUsSUFBSTtZQUN4QixrQkFBa0IsRUFBRSxLQUFLO1lBQ3pCLGdCQUFnQixFQUFFLEtBQUs7U0FDMUI7S0FDSjtJQUNELFlBQVksRUFBRTtRQUNWLFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFNBQVM7d0JBQ25CLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsU0FBUzthQUNoQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsbUJBQW1CO3FCQUM5QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsaUJBQWlCO2FBQ3hCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxtQkFBbUI7cUJBQzlCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxnQkFBZ0I7YUFDdkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLE9BQU87YUFDZDtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsbUJBQW1CO3FCQUM5QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxtQkFBbUI7cUJBQzlCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxPQUFPO2FBQ2Q7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGFBQWE7YUFDcEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGlCQUFpQjthQUN4QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsbUJBQW1CO3FCQUM5QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsV0FBVzthQUNsQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsbUJBQW1CO3FCQUM5QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsZUFBZTthQUN0QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsbUJBQW1CO3FCQUM5QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsTUFBTTthQUNiO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxtQkFBbUI7cUJBQzlCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxZQUFZO2FBQ25CO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxtQkFBbUI7cUJBQzlCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxnQkFBZ0I7YUFDdkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGNBQWM7YUFDckI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsbUJBQW1CO3FCQUM5QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsaUJBQWlCO2FBQ3hCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxtQkFBbUI7cUJBQzlCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxpQkFBaUI7YUFDeEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGFBQWE7YUFDcEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFFBQVE7YUFDZjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsbUJBQW1CO3FCQUM5QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsZUFBZTthQUN0QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsbUJBQW1CO3FCQUM5QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsY0FBYzthQUNyQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsbUJBQW1CO3FCQUM5QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsZ0JBQWdCO2FBQ3ZCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxtQkFBbUI7cUJBQzlCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxhQUFhO2FBQ3BCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSw4QkFBOEI7YUFDckM7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUscUNBQXFDO2FBQzVDO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxtQkFBbUI7YUFDMUI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFdBQVc7YUFDbEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsa0JBQWtCO2FBQ3pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxzQkFBc0I7YUFDN0I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGVBQWU7YUFDdEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDJCQUEyQjthQUNsQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsWUFBWTthQUNuQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsT0FBTzthQUNkO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxnQkFBZ0I7YUFDdkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDBCQUEwQjthQUNqQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxlQUFlO2FBQ3RCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxZQUFZO2FBQ25CO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxpQkFBaUI7YUFDeEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGVBQWU7YUFDdEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsV0FBVzthQUNsQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsT0FBTzthQUNkO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxlQUFlO2FBQ3RCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxRQUFRO2FBQ2Y7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGVBQWU7YUFDdEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGdCQUFnQjthQUN2QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUseUJBQXlCO2FBQ2hDO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxZQUFZO2FBQ25CO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxvQkFBb0I7YUFDM0I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGdCQUFnQjthQUN2QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsbUNBQW1DO2FBQzFDO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxVQUFVO2FBQ2pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxZQUFZO2FBQ25CO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxjQUFjO2FBQ3JCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxzQkFBc0I7YUFDN0I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsWUFBWTthQUNuQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxpQkFBaUI7YUFDeEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGdCQUFnQjthQUN2QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsYUFBYTthQUNwQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsa0JBQWtCO2FBQ3pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxvQkFBb0I7YUFDM0I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFFBQVE7YUFDZjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsZ0JBQWdCO2FBQ3ZCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSx3QkFBd0I7YUFDL0I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFdBQVc7YUFDbEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLE1BQU07YUFDYjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsWUFBWTthQUNuQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxVQUFVO2FBQ2pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxNQUFNO2FBQ2I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFdBQVc7YUFDbEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFFBQVE7YUFDZjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsV0FBVzthQUNsQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsT0FBTzthQUNkO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxZQUFZO2FBQ25CO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxxQkFBcUI7YUFDNUI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGdCQUFnQjthQUN2QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxVQUFVO2FBQ2pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxVQUFVO2FBQ2pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxRQUFRO2FBQ2Y7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFdBQVc7YUFDbEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFdBQVc7YUFDbEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLHdCQUF3QjtxQkFDbkM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx3QkFBd0I7d0JBQ2xDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGdCQUFnQjthQUN2QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHdCQUF3Qjt3QkFDbEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsT0FBTzthQUNkO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxlQUFlO2FBQ3RCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSx1QkFBdUI7d0JBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7cUJBQ25DO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsd0JBQXdCO3dCQUNsQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxRQUFRO2FBQ2Y7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsaUJBQWlCO3FCQUM1QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDJCQUEyQjt3QkFDckMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsT0FBTzthQUNkO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxRQUFRO2FBQ2Y7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFFBQVE7YUFDZjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsaUJBQWlCO3FCQUM1QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDJCQUEyQjt3QkFDckMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsU0FBUzthQUNoQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsaUJBQWlCO3FCQUM1QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDJCQUEyQjt3QkFDckMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxRQUFRO2FBQ2Y7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFdBQVc7YUFDbEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHdCQUF3QjthQUMvQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsaUJBQWlCO3FCQUM1QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDJCQUEyQjt3QkFDckMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsaUJBQWlCO3FCQUM1QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDJCQUEyQjt3QkFDckMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxVQUFVO2FBQ2pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSx3QkFBd0I7YUFDL0I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsaUJBQWlCO3FCQUM1QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDJCQUEyQjt3QkFDckMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsU0FBUzthQUNoQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsaUJBQWlCO3FCQUM1QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDJCQUEyQjt3QkFDckMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsaUJBQWlCO3FCQUM1QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDJCQUEyQjt3QkFDckMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxRQUFRO2FBQ2Y7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFdBQVc7YUFDbEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsaUJBQWlCO3FCQUM1QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDJCQUEyQjt3QkFDckMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxlQUFlO2FBQ3RCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxpQkFBaUI7cUJBQzVCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMkJBQTJCO3dCQUNyQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxnQkFBZ0I7YUFDdkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGdCQUFnQjt3QkFDMUIsTUFBTSxFQUFFLGlCQUFpQjtxQkFDNUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwyQkFBMkI7d0JBQ3JDLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGFBQWE7YUFDcEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGtCQUFrQjt3QkFDNUIsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxxQkFBcUI7d0JBQy9CLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGlCQUFpQjthQUN4QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsU0FBUzt3QkFDbkIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxVQUFVO2FBQ2pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGVBQWU7YUFDdEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxlQUFlO3FCQUMxQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsZUFBZTthQUN0QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxpQkFBaUI7YUFDeEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxlQUFlO3FCQUMxQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsT0FBTzthQUNkO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSx1QkFBdUI7YUFDOUI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxlQUFlO3FCQUMxQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsYUFBYTthQUNwQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxlQUFlO2FBQ3RCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxxQkFBcUI7YUFDNUI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxlQUFlO3FCQUMxQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsY0FBYzthQUNyQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxhQUFhO2FBQ3BCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG1CQUFtQjthQUMxQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLE1BQU07YUFDYjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxjQUFjO2FBQ3JCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxlQUFlO3FCQUMxQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsWUFBWTthQUNuQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxZQUFZO2FBQ25CO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLE9BQU87YUFDZDtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxnQkFBZ0I7YUFDdkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxlQUFlO3FCQUMxQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsbUJBQW1CO2FBQzFCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGdCQUFnQjthQUN2QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxtQkFBbUI7YUFDMUI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxlQUFlO3FCQUMxQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsY0FBYzthQUNyQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxnQkFBZ0I7YUFDdkI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGNBQWM7d0JBQ3hCLE1BQU0sRUFBRSxlQUFlO3FCQUMxQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsa0JBQWtCO2FBQ3pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG1CQUFtQjthQUMxQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxVQUFVO2FBQ2pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsY0FBYzt3QkFDeEIsTUFBTSxFQUFFLGVBQWU7cUJBQzFCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsaUJBQWlCO3dCQUMzQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxjQUFjO2FBQ3JCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxjQUFjO3dCQUN4QixNQUFNLEVBQUUsZUFBZTtxQkFDMUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsU0FBUzt3QkFDbkIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxzQkFBc0I7YUFDN0I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHdDQUF3QzthQUMvQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsc0NBQXNDO2FBQzdDO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxlQUFlO2FBQ3RCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSwrQkFBK0I7YUFDdEM7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDZCQUE2QjthQUNwQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsMENBQTBDO2FBQ2pEO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSwyQkFBMkI7YUFDbEM7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLE9BQU87YUFDZDtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsb0NBQW9DO2FBQzNDO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxrQ0FBa0M7YUFDekM7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtDQUFrQzthQUN6QztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsd0NBQXdDO2FBQy9DO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxxREFBcUQ7YUFDNUQ7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDRCQUE0QjthQUNuQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsT0FBTzthQUNkO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSx1Q0FBdUM7YUFDOUM7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDJCQUEyQjthQUNsQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUscUJBQXFCO3FCQUNoQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsb0JBQW9CO2FBQzNCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxxQkFBcUI7cUJBQ2hDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSwrQ0FBK0M7YUFDdEQ7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLHFCQUFxQjtxQkFDaEM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDBCQUEwQjthQUNqQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxrQkFBa0I7YUFDekI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNDQUFzQzthQUM3QztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUscUJBQXFCO2FBQzVCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSx5QkFBeUI7YUFDaEM7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGNBQWM7YUFDckI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDBCQUEwQjthQUNqQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsb0JBQW9CO2FBQzNCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxxQkFBcUI7YUFDNUI7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsUUFBUTtZQUNoQixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHlCQUF5QjthQUNoQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxRQUFRO1lBQ2hCLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUscUJBQXFCO2FBQzVCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxZQUFZO2FBQ25CO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsV0FBVztxQkFDdEI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxVQUFVO3dCQUNwQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLFFBQVE7WUFDaEIsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSx3QkFBd0I7YUFDL0I7U0FDSjtLQUNKO0NBQ0osQ0FBQSJ9